// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file unacast/boundaries/collectionpb/v1/collection.proto (package unacast.boundaries.collectionpb.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from enum unacast.boundaries.collectionpb.v1.VersionState
 */
export enum VersionState {
  /**
   * @generated from enum value: VERSION_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: VERSION_STATE_ARCHIVED = 1;
   */
  ARCHIVED = 1,

  /**
   * @generated from enum value: VERSION_STATE_DRAFT = 2;
   */
  DRAFT = 2,

  /**
   * @generated from enum value: VERSION_STATE_PUBLISHED = 3;
   */
  PUBLISHED = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(VersionState)
proto3.util.setEnumType(VersionState, "unacast.boundaries.collectionpb.v1.VersionState", [
  { no: 0, name: "VERSION_STATE_UNSPECIFIED" },
  { no: 1, name: "VERSION_STATE_ARCHIVED" },
  { no: 2, name: "VERSION_STATE_DRAFT" },
  { no: 3, name: "VERSION_STATE_PUBLISHED" },
]);

/**
 * @generated from message unacast.boundaries.collectionpb.v1.Collection
 */
export class Collection extends Message<Collection> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string owner_id = 2;
   */
  ownerId = "";

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: string description = 4;
   */
  description = "";

  constructor(data?: PartialMessage<Collection>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.collectionpb.v1.Collection";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "owner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Collection {
    return new Collection().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Collection {
    return new Collection().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Collection {
    return new Collection().fromJsonString(jsonString, options);
  }

  static equals(a: Collection | PlainMessage<Collection> | undefined, b: Collection | PlainMessage<Collection> | undefined): boolean {
    return proto3.util.equals(Collection, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.collectionpb.v1.CollectionVersion
 */
export class CollectionVersion extends Message<CollectionVersion> {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId = "";

  /**
   * @generated from field: int32 version = 2;
   */
  version = 0;

  /**
   * @generated from field: unacast.boundaries.collectionpb.v1.VersionState state = 3;
   */
  state = VersionState.UNSPECIFIED;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string name = 6;
   */
  name = "";

  /**
   * @generated from field: string description = 7;
   */
  description = "";

  constructor(data?: PartialMessage<CollectionVersion>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.collectionpb.v1.CollectionVersion";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "state", kind: "enum", T: proto3.getEnumType(VersionState) },
    { no: 4, name: "created_at", kind: "message", T: Timestamp },
    { no: 5, name: "updated_at", kind: "message", T: Timestamp },
    { no: 6, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CollectionVersion {
    return new CollectionVersion().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CollectionVersion {
    return new CollectionVersion().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CollectionVersion {
    return new CollectionVersion().fromJsonString(jsonString, options);
  }

  static equals(a: CollectionVersion | PlainMessage<CollectionVersion> | undefined, b: CollectionVersion | PlainMessage<CollectionVersion> | undefined): boolean {
    return proto3.util.equals(CollectionVersion, a, b);
  }
}

